export default __webpack_public_path__ + "static/media/edit.cabdffd3.svg";